import AbilitySavingThrowsPane from './AbilitySavingThrowsPane';

export default AbilitySavingThrowsPane;
export { AbilitySavingThrowsPane };
